const state = {
  allFlags: []
};

const getters = {
  allFlags: state => {
    return state.allFlags;
  }
};

const mutations = {
  SET_ALLFLAGS(state, allFlags) {
    state.allFlags = allFlags;
  }
};

const actions = {
  setAllFlags({ commit }, data) {
    commit("SET_ALLFLAGS", data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
